import { render, staticRenderFns } from "./TheDrawerLocale.vue?vue&type=template&id=50d5203c"
import script from "./TheDrawerLocale.vue?vue&type=script&lang=js"
export * from "./TheDrawerLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports